import { render, staticRenderFns } from "./DeliveryContact.vue?vue&type=template&id=753f103e&"
import script from "./DeliveryContact.vue?vue&type=script&lang=js&"
export * from "./DeliveryContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports